import * as PropTypes from "../prop-types";

export function contentOf(nodeOrRenderFn: PropTypes.ReactNodeOrRenderFn): PropTypes.ReactNodeLike {
    return typeof nodeOrRenderFn === "function"
        ? (nodeOrRenderFn as (() => PropTypes.ReactNodeLike))()
        : nodeOrRenderFn;
}
